<big-ui-link
    *transloco="let t; prefix: 'search'"
    class="block"
    [href]="item.url"
    [linkClass]="'block hover:bg-primary-25 no-underline'"
    [ngClass]="{
        'my-6': item.type === 'big_form',
    }">
    <div class="container grid grid-cols-12 gap-6">
        <div
            class="col-span-12 p-6 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3"
            [ngClass]="{
                'bg-primary-25': item.type === 'big_form',
            }">
            @if (item.type === 'big_form') {
                <div class="mb-2 text-primary h5">{{ t('simplyFillOutOnline') }}</div>
            }

            <h4 class="flex mt-0 mb-2">
                {{ item.title }}

                @if (isPrivateUrl) {
                    <span class="w-5 ml-2">
                        <big-icon
                            [icon]="myBigIcon"
                            [size]="'w-5'"
                            class="fill-current" />
                    </span>
                }
            </h4>

            <p
                class="mb-2"
                [innerHTML]="item.body | highlight: highlightString"></p>

            @if (item.breadcrumb.length) {
                <big-ui-breadcrumb
                    class="-my-1.5"
                    [entries]="item.breadcrumb" />
            }
        </div>
    </div>
</big-ui-link>
